/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    array, string, number, func,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import Slider from 'react-slick';
import ReactHtmlParser from 'react-html-parser';
import ReactMarkdown from 'react-markdown';
import { clubComponentType } from '../common/types';

const useStyles = makeStyles((theme) => ({
    carouselContainer: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        '& .slick-list': {
            overflow: 'hidden',
            margin: '0 auto',
        },
        '& .slick-slide': {
            display: 'table-cell',
            verticalAlign: 'middle',
            overflow: 'hidden',
            paddingRight: '10px',
            '&>div': {
                display: 'flex',
            },
        },
        '& .slick-track': {
            display: 'flex',
            flexDirection: 'row',
            overflow: 'hidden',
        },
        '& .slick-prev, & .slick-next': {
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            top: '40%',
            backgroundColor: 'rgba(255, 255, 255, 0)',
            boxSizing: 'border-box',
            color: theme.palette.desktopHeaderMenu?.text || '#333333',
            width: '6%',
            position: 'absolute',
            zIndex: '9999',
            '& svg': {
                height: 'inherit',
            },
            '& img': {
                width: '100%',
            },
        },
        '& .slick-prev': {
            left: '-6px',
            transform: 'rotate(90deg)',
        },
        '& .slick-next': {
            right: '-6px',
            transform: 'rotate(-90deg)',
        },
    },
    monthDescriptionSummary: {
        maxWidth: '350px',
        marginLeft: '1rem',
        [theme.breakpoints.down(1366)]: {
            maxWidth: '300px',
        },
        [theme.breakpoints.down('md')]: {
            margin: '0px 1rem 0px 0px',
        },
    },
    productImageWrapperMonth: {
        flex: '1 1 auto',
        maxWidth: '300px',
        minWidth: '300px',
        height: '100%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            order: '1',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
    },
    flexContainer: {
        display: 'flex !important',
        justifyContent: 'center',
    },
    wrapper: {
        width: '60%',
        maxHeight: '350px',
        margin: '0 auto',
        [theme.breakpoints.down(1400)]: {
            width: '70%',
        },
        [theme.breakpoints.down(1024)]: {
            width: '90%',
        },
    },
    wrapper3Nup: {
        maxWidth: '100%',
        margin: '0 auto',
    },
    wrapper9Nup: {
        maxWidth: '80%',
        margin: '0 auto',
        [theme.breakpoints.down(1640)]: {
            maxWidth: '70%',
        },
        [theme.breakpoints.down(1400)]: {
            maxWidth: 'calc(100% - 100px)',
        },
    },
    wrapper6Nup: {
        maxWidth: '90%',
        margin: '0 auto',
    },
}));

const ClubPDPDialogSlider = ({
    data, clubComponents, cdnLink, selectedComponentMonth, navigate, renderCss,
}) => {
    const [state, setState] = useState({
        nav1: null,
        nav2: null,
    });
    const seed = useUIDSeed();
    const classes = useStyles();
    const slider1 = useRef();
    const slider2 = useRef();

    useEffect(() => {
        setState({
            nav1: slider1.current,
            nav2: slider2.current,
        });
    }, []);

    const { nav1, nav2 } = state;

    const prevArrow = () => (
        <div data-testid="navigate-click-prev">
            <img alt="Previous Link"  role="presentation" onClick={() =>  navigate('prev')} src="https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/navigator.svg" />
        </div>
    );
    const nextArrow = () => (
        <div data-testid="navigate-click-next">
            <img alt="Next Link"  role="presentation"  onClick={() => navigate()} src="https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/navigator.svg" />
        </div>
    );
    return (
        <>
            <Slider
                asNavFor={nav2}
                ref={(slider) => { slider1.current = slider; }}
                slidesToShow={data.length}
                swipeToSlide={false}
                focusOnSelect
                initialSlide={selectedComponentMonth}
                slidesToScroll={1}
                variableWidth
                className={`carousel-container ${classes.carouselContainer}`}
            >
                {data.map((item) => (
                    <div key={seed(item)}>
                        { item }
                    </div>
                ))}
            </Slider>

            <Slider
                asNavFor={nav1}
                ref={(slider) => { slider2.current = slider; }}
                className={`carousel-nav2" ${classes.carouselContainer} ${renderCss(classes)}`}
                slidesToScroll={1}
                nextArrow={nextArrow()}
                prevArrow={prevArrow()}
                slidesToShow={1}
                initialSlide={selectedComponentMonth}
                // afterChange={(current) => { afterChange(current); }}
            >
                {clubComponents.map((item, key) => (
                    <div  key={seed(item)} data-testid={`selected-component-${key}`} className={classes.flexContainer}>
                        <div className={classes.productImageWrapperMonth}>
                            <img
                                className={classes.productImage}
                                src={`${cdnLink}${item?.image?.name}${'z.jpg?width=300&height=328&auto=webp'}`}
                                alt={item?.name}
                            />
                        </div>
                        <div className={classes.monthDescriptionSummary}>
                            <h2>{ReactHtmlParser(item?.month)} - {ReactHtmlParser(item?.name)}</h2>
                            <p>
                                <ReactMarkdown
                                    source={item.longDescription || ''}
                                    escapeHtml={false}
                                />
                                <ReactMarkdown
                                    source={item.productContents || ''}
                                    escapeHtml={false}
                                />
                            </p>
                        </div>
                    </div>
                ))}
            </Slider>
        </>
    );
};
ClubPDPDialogSlider.propTypes = {
    data: array,
    cdnLink: string,
    clubComponents: clubComponentType.isRequired,
    selectedComponentMonth: number,
    navigate: func.isRequired,
    renderCss: func,
};
ClubPDPDialogSlider.defaultProps = {
    data: [],
    cdnLink: '',
    renderCss: () => {},
    selectedComponentMonth: 0,
};
export default ClubPDPDialogSlider;
